/**
 * 表紙・特集商品選定依頼確認（グループ長用）画面の特集候補商品クラス
 *
 * @export FeatureCandidateGoods
 * @class FeatureCandidateGoods
 */
export class FeatureCandidateGoods {
  constructor(
    public orderCode: string,
    public mediumType: string,
    public mediumTypeName: string,
    public featureCode: string,
    public featureName: string,
    public featureDisplay: string,
    public classCode: string,
    public classCodeName: string,
    public classDisplay: string,
    public middleClassCode: string,
    public middleClassCodeName: string,
    public middleClassDispaly: string,
    public pcode: string,
    public guideGoodsName: string,
    public guideStandardName: string,
    public thisTimeSupplyPrice: number,
    public pricePattern: number,
    public pricePatternName: string,
    public planNumAiPrediction: number,
    public planNum: number,
    public planSupplyBudget: number,
    public dispPlanSupplyBudget: string,
    public thisTimeCostPrice: number,
    public gpr: number,
    public requestBuyerUserId: string,
    public requestBuyerUserName: string,
    public remarks: string,
  ) {}
}
